import { PortfolioAttribute } from './PortfolioAttribute'

export default PortfolioAttribute
